import { useNavigate } from "react-router-dom";
import TopNav from "@/components/TopNav";
import { Button } from "@/components/ui/button";
import { XCircle } from "@phosphor-icons/react";

export default function BillingCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-ivory grain-bg">
      <TopNav />
      <main className="max-w-2xl mx-auto px-5 md:px-10 py-20 text-center" data-testid="billing-cancel-page">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-sage/40 text-sageGray mb-6">
          <XCircle size={32} weight="duotone" />
        </span>
        <h1 className="font-display text-3xl md:text-4xl text-forest">Checkout cancelled</h1>
        <p className="text-sageGray mt-4 max-w-md mx-auto leading-relaxed">
          No worries — your circle wasn't created and no card was charged. Pop back to the dashboard whenever you're ready to try again.
        </p>
        <Button onClick={() => navigate("/dashboard")} className="mt-8 bg-forest hover:bg-forestSoft text-ivory rounded-full px-7" data-testid="cancel-back-dashboard">
          Back to dashboard
        </Button>
      </main>
    </div>
  );
}
